module.exports = __webpack_public_path__ + "static/media/alert_bell.cbd4f6d9.svg";